/**
 * Faceted Search - Filters, Sorting, Load More, and Accordion functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    initializeHtmxFilters();
    initializeMobileFilters();
    initializeProductPrefetch();
    console.log('Faceted Search Filters Initialized!');
});

// Re-initialize after htmx swaps content
document.body.addEventListener('htmx:afterSwap', function(event) {
    if (event.detail.target.id === 'products-wrapper' ||
        event.detail.target.id === 'products-container' ||
        event.detail.target.id === 'products-grid') {
        initializeHtmxFilters();
        initializeMobileFilters();
        initializeProductPrefetch();
    }
});

// Handle browser back/forward buttons
window.addEventListener('popstate', function(event) {
    window.location.reload();
});

function initializeHtmxFilters() {
    const form = document.getElementById('filterForm');
    if (!form) return;

    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    const sortSelect = document.getElementById('sortSelect');
    const clearFiltersButtons = document.querySelectorAll('.clear-filters-btn');
    const loadMoreBtn = document.querySelector('.products-load-more__button');
    const removeFilterButtons = document.querySelectorAll('.remove-filter-btn');
    const mobileRemoveFilterButtons = document.querySelectorAll('.mobile-remove-filter-btn');
    const mobileClearAllButton = document.querySelector('.mobile-clear-all-filters');
    const filterToggles = document.querySelectorAll('.filter__toggle');

    // Handle filter checkbox changes
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            triggerHtmxUpdate();
        });
    });

    // Handle sort dropdown change
    if (sortSelect) {
        sortSelect.addEventListener('change', function() {
            triggerHtmxUpdate();
        });
    }

    // Handle clear filters buttons
    clearFiltersButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            clearAllFilters();
        });
    });

    // Handle remove individual filter buttons
    removeFilterButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            removeIndividualFilter(this);
        });
    });

    // Handle mobile remove individual filter buttons
    mobileRemoveFilterButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            removeIndividualFilter(this);
        });
    });

    // Handle mobile clear all filters button
    if (mobileClearAllButton) {
        mobileClearAllButton.addEventListener('click', function(e) {
            e.preventDefault();
            clearAllFilters();
        });
    }

    // Handle accordion toggles
    filterToggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            toggleFilterGroup(this);
        });
    });

    // Make header clickable for accordion
    const filterHeaders = document.querySelectorAll('.filter__header');
    filterHeaders.forEach(header => {
        header.addEventListener('click', function(e) {
            if (!e.target.closest('.filter__toggle')) {
                const toggle = this.querySelector('.filter__toggle');
                if (toggle) {
                    toggleFilterGroup(toggle);
                }
            }
        });
    });

    // Handle load more button
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function(e) {
            e.preventDefault();
            loadMoreProducts(this);
        });
    }

    // Only allow one price range to be selected
    const priceCheckboxes = form.querySelectorAll('input[name="price_range"]');
    priceCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                priceCheckboxes.forEach(cb => {
                    if (cb !== this) cb.checked = false;
                });
            }
        });
    });
}

function toggleFilterGroup(toggleButton) {
    const filterHeader = toggleButton.closest('.filter__header');
    const filterBody = filterHeader.nextElementSibling;
    const icon = toggleButton.querySelector('.filter__toggle-icon');

    const isCollapsed = filterBody.classList.contains('collapsed');

    if (isCollapsed) {
        filterBody.classList.remove('collapsed');
        icon.style.transform = 'rotate(0deg)';
    } else {
        filterBody.classList.add('collapsed');
        icon.style.transform = 'rotate(-90deg)';
    }
}

function triggerHtmxUpdate(page = null) {
    const form = document.getElementById('filterForm');
    const sortSelect = document.getElementById('sortSelect');
    const params = new URLSearchParams();

    // Add page parameter
    if (page) {
        params.append('page', page);
    }

    // Add sort parameter
    if (sortSelect) {
        const sortValue = sortSelect.value;
        if (sortValue && sortValue !== 'newest') {
            params.append('sort', sortValue);
        }
    }

    // Add price filter
    const priceCheckbox = form.querySelector('input[name="price_range"]:checked');
    if (priceCheckbox) {
        const min = priceCheckbox.dataset.min;
        const max = priceCheckbox.dataset.max;
        if (min) params.append('price_min', min);
        if (max && max !== 'null') params.append('price_max', max);
    }

    // Add attribute filters
    const attributeCheckboxes = form.querySelectorAll('input[type="checkbox"]:not([name="price_range"]):checked');
    attributeCheckboxes.forEach(checkbox => {
        params.append(checkbox.name, checkbox.value);
    });

    // Build URL
    const url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');

    console.log('Fetching URL:', url);

    // Show loading indicator
    const loadingIndicator = document.getElementById('htmx-loading');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'flex';
    }

    // Use htmx to fetch and swap content
    htmx.ajax('GET', url, {
        target: '#products-wrapper',
        swap: 'outerHTML'
    }).then(function() {
        // Hide loading indicator
        if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
        }

        // Update URL manually using History API
        window.history.pushState({}, '', url);

        // Scroll to top smoothly
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

function clearAllFilters() {
    const url = window.location.pathname;

    console.log('Clearing all filters, fetching:', url);

    // Show loading indicator
    const loadingIndicator = document.getElementById('htmx-loading');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'flex';
    }

    // Use htmx to fetch and swap content
    htmx.ajax('GET', url, {
        target: '#products-wrapper',
        swap: 'outerHTML'
    }).then(function() {
        // Hide loading indicator
        if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
        }

        // Update URL to base path
        window.history.pushState({}, '', url);

        // Scroll to top smoothly
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

function removeIndividualFilter(button) {
    const form = document.getElementById('filterForm');
    const filterType = button.dataset.filterType;

    if (filterType === 'price') {
        const priceCheckbox = form.querySelector('input[name="price_range"]:checked');
        if (priceCheckbox) {
            priceCheckbox.checked = false;
        }
    } else if (filterType === 'attribute') {
        const filterKey = button.dataset.filterKey;
        const filterValue = button.dataset.filterValue;
        const checkbox = form.querySelector(`input[name="${filterKey}[]"][value="${filterValue}"]`);
        if (checkbox) {
            checkbox.checked = false;
        }
    }

    triggerHtmxUpdate();
}

function loadMoreProducts(button) {
    const form = document.getElementById('filterForm');
    const sortSelect = document.getElementById('sortSelect');
    const nextPage = parseInt(button.dataset.nextPage);
    const totalPages = parseInt(button.dataset.totalPages);
    const totalProducts = parseInt(button.dataset.totalProducts);
    const params = new URLSearchParams();

    // Add page parameter
    params.append('page', nextPage);

    // Add load_more flag
    params.append('load_more', 'true');

    // Add sort parameter
    if (sortSelect) {
        const sortValue = sortSelect.value;
        if (sortValue && sortValue !== 'newest') {
            params.append('sort', sortValue);
        }
    }

    // Add price filter
    const priceCheckbox = form.querySelector('input[name="price_range"]:checked');
    if (priceCheckbox) {
        const min = priceCheckbox.dataset.min;
        const max = priceCheckbox.dataset.max;
        if (min) params.append('price_min', min);
        if (max && max !== 'null') params.append('price_max', max);
    }

    // Add attribute filters
    const attributeCheckboxes = form.querySelectorAll('input[type="checkbox"]:not([name="price_range"]):checked');
    attributeCheckboxes.forEach(checkbox => {
        params.append(checkbox.name, checkbox.value);
    });

    // Build URL for AJAX request
    const ajaxUrl = window.location.pathname + '?' + params.toString();

    // Build URL for browser history
    const historyParams = new URLSearchParams(params);
    historyParams.delete('load_more');
    const historyUrl = window.location.pathname + '?' + historyParams.toString();

    console.log('Loading more products from:', ajaxUrl);

    // Disable button and show loading state
    button.disabled = true;
    const originalButtonHTML = button.innerHTML;
    button.innerHTML = 'Ucitavanje...';

    // Use htmx to fetch and append products
    htmx.ajax('GET', ajaxUrl, {
        target: '#products-grid',
        swap: 'beforeend'
    }).then(function() {
        // Update the displayed count and progress bar
        const currentCount = document.querySelectorAll('#products-grid > *').length;
        const loadMoreText = document.getElementById('load-more-text');
        const progressBar = document.getElementById('progress-bar');

        if (loadMoreText) {
            loadMoreText.textContent = `Prikazano ${currentCount} od ${totalProducts} proizvoda`;
        }

        if (progressBar) {
            const progressPercentage = Math.round((currentCount / totalProducts) * 100);
            progressBar.style.width = progressPercentage + '%';
        }

        // Update URL in browser
        window.history.pushState({}, '', historyUrl);

        // Update button or remove it
        if (nextPage >= totalPages) {
            button.remove();
        } else {
            button.dataset.nextPage = nextPage + 1;
            button.disabled = false;
            button.innerHTML = originalButtonHTML;
        }
    }).catch(function() {
        button.disabled = false;
        button.innerHTML = originalButtonHTML;
    });
}

/**
 * Initialize mobile filter modal
 */
function initializeMobileFilters() {
    const mobileFilterBtn = document.getElementById('mobileFilterBtn');
    const mobileFilterModal = document.getElementById('mobileFilterModal');
    const closeBtns = [
        document.getElementById('closeMobileFilters'),
        document.getElementById('closeMobileFiltersX')
    ];
    const mobileFiltersContainer = document.getElementById('mobileFiltersContainer');
    const desktopFilters = document.getElementById('filterForm');

    if (!mobileFilterBtn || !mobileFilterModal || !mobileFiltersContainer || !desktopFilters) {
        return;
    }

    function cloneFiltersToMobile() {
        mobileFiltersContainer.innerHTML = '';
        const clonedForm = desktopFilters.cloneNode(true);
        clonedForm.id = 'mobileFilterForm';
        mobileFiltersContainer.appendChild(clonedForm);
        initializeMobileFormListeners();
    }

    function initializeMobileFormListeners() {
        const mobileForm = document.getElementById('mobileFilterForm');
        if (!mobileForm) return;

        const checkboxes = mobileForm.querySelectorAll('input[type="checkbox"]');
        const filterToggles = mobileForm.querySelectorAll('.filter__toggle');
        const filterHeaders = mobileForm.querySelectorAll('.filter__header');

        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function() {
                const desktopCheckbox = desktopFilters.querySelector(`input[name="${this.name}"][value="${this.value}"]`);
                if (desktopCheckbox) {
                    desktopCheckbox.checked = this.checked;
                }
                triggerHtmxUpdate();
                closeMobileModal();
            });
        });

        filterToggles.forEach(toggle => {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                toggleFilterGroup(this);
            });
        });

        filterHeaders.forEach(header => {
            header.addEventListener('click', function(e) {
                if (!e.target.closest('.filter__toggle')) {
                    const toggle = this.querySelector('.filter__toggle');
                    if (toggle) {
                        toggleFilterGroup(toggle);
                    }
                }
            });
        });
    }

    function openMobileModal() {
        cloneFiltersToMobile();
        mobileFilterModal.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileModal() {
        mobileFilterModal.classList.remove('active');
        document.body.style.overflow = '';
    }

    if (mobileFilterBtn) {
        mobileFilterBtn.addEventListener('click', openMobileModal);
    }

    closeBtns.forEach(btn => {
        if (btn) {
            btn.addEventListener('click', closeMobileModal);
        }
    });

    mobileFilterModal.addEventListener('click', function(e) {
        if (e.target === mobileFilterModal) {
            closeMobileModal();
        }
    });
}

/**
 * Initialize product prefetch on hover
 * Preloads product pages when user hovers over product cards for instant navigation
 */
function initializeProductPrefetch() {
    // Track prefetched URLs to avoid duplicates
    const prefetchedUrls = new Set();

    // Get all product card links
    const productLinks = document.querySelectorAll('.fs-product-card__link');

    productLinks.forEach(link => {
        let prefetchTimeout = null;

        link.addEventListener('mouseenter', function() {
            const url = this.href;

            // Don't prefetch if already prefetched
            if (prefetchedUrls.has(url)) {
                return;
            }

            // Delay prefetch slightly to avoid prefetching on accidental hovers
            prefetchTimeout = setTimeout(() => {
                prefetchUrl(url);
                prefetchedUrls.add(url);
            }, 100);
        });

        link.addEventListener('mouseleave', function() {
            // Cancel prefetch if user leaves before timeout
            if (prefetchTimeout) {
                clearTimeout(prefetchTimeout);
                prefetchTimeout = null;
            }
        });

        // Also prefetch on focus (for keyboard navigation)
        link.addEventListener('focus', function() {
            const url = this.href;
            if (!prefetchedUrls.has(url)) {
                prefetchUrl(url);
                prefetchedUrls.add(url);
            }
        });
    });

    // Also prefetch category/subcategory links on hover
    const categoryLinks = document.querySelectorAll('.category-tree__link');
    categoryLinks.forEach(link => {
        let prefetchTimeout = null;

        link.addEventListener('mouseenter', function() {
            const url = this.href;

            if (prefetchedUrls.has(url)) {
                return;
            }

            prefetchTimeout = setTimeout(() => {
                prefetchUrl(url);
                prefetchedUrls.add(url);
            }, 150);
        });

        link.addEventListener('mouseleave', function() {
            if (prefetchTimeout) {
                clearTimeout(prefetchTimeout);
                prefetchTimeout = null;
            }
        });
    });
}

/**
 * Prefetch a URL using link rel="prefetch"
 * @param {string} url - The URL to prefetch
 */
function prefetchUrl(url) {
    // Check if browser supports prefetch
    if (!('connection' in navigator) ||
        (navigator.connection && !navigator.connection.saveData)) {

        // Check if link already exists
        if (document.querySelector(`link[href="${url}"]`)) {
            return;
        }

        // Create prefetch link
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url;
        link.as = 'document';

        // Add to head
        document.head.appendChild(link);

        console.log('Prefetched:', url);
    }
}

/**
 * Preconnect to external resources
 * Call this for third-party resources that will be needed
 * @param {string} origin - The origin to preconnect to
 */
function preconnectTo(origin) {
    if (document.querySelector(`link[href="${origin}"]`)) {
        return;
    }

    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = origin;
    link.crossOrigin = 'anonymous';

    document.head.appendChild(link);
}
